import {
  EditOutlined,
  EnvironmentOutlined,
  EyeOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Badge, Button, Card, Spin, Tag } from "antd";
import { genericStyles, TagColorMap } from "../../../constant";
import Avatar from "../../../components/generic/Avatar";

const TeamsCard = (props) => {
  const { teams = [], isLoading, setSelectedTeam } = props;
  return (
    <div>
      {isLoading ? (
        <div>
          <Spin tip="Loading" className="flex-center h-100" size="large" />
        </div>
      ) : teams.length === 0 ? (
        <div className="team-state ">
          <div className="empty-icon">
            <TeamOutlined />
          </div>
          <div className="empty-text">
            No teams yet. Create your first team!
          </div>
        </div>
      ) : (
        <div className="team-grid">
          {teams.map((team) => (
            <Card key={team.id} className="team-card">
              <div className="card-header">
                <h3 className="team-name">{team.name}</h3>
                <span className="branch-tag">
                  <EnvironmentOutlined />
                  {team.branch?.name}
                </span>
              </div>

              <div className="leader-section">
                <div className="leader-header">
                  <Avatar size={42} user={team.teamLead} />
                  <div className="leader-info">
                    <p className="name">
                      {team.teamLead?.first_name} {team.teamLead?.last_name}
                    </p>
                    <p className="role-tag">{team.teamLead?.email}</p>
                  </div>
                  <Badge
                    count={team.team_members?.length}
                    style={{ background: genericStyles.primaryColor }}
                  />
                </div>
              </div>

              <div className="topic-section">
                <span className="topics-label">Topics</span>
                <div>
                  {team.topics.map((topic, idx) => (
                    <Tag
                      key={topic.id}
                      color={TagColorMap[idx % TagColorMap.length]}
                    >
                      {topic.name}
                    </Tag>
                  ))}
                </div>
              </div>

              <div className="action-section">
                <Button
                  className="view-btn"
                  icon={<EyeOutlined />}
                  onClick={() => setSelectedTeam({ ...team, isView: true })}
                >
                  View
                </Button>
                <Button
                  className="edit-btn"
                  type="primary"
                  icon={<EditOutlined />}
                  onClick={() => setSelectedTeam(team)}
                >
                  Edit
                </Button>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default TeamsCard;
